import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {getSupabase } from "../lib/supabase";

export default function AdminLayout() {
  const navigate = useNavigate();
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  /* ===== THEME HANDLING ===== */
  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  async function handleLogout() {
     const supabase = await getSupabase();
    
    await supabase.auth.signOut();
    navigate("/admin/login", { replace: true });
  }

  const linkClass = ({ isActive }) =>
    `
    block rounded-xl px-4 py-3 text-sm font-medium transition-all
    ${
      isActive
        ? "bg-[rgb(var(--brand-primary))] text-white shadow-lg"
        : "text-slate-700 hover:bg-white/60 dark:text-slate-300 dark:hover:bg-white/10"
    }
  `;

  return (
    <div className="min-h-screen bg-[rgb(var(--brand-surface))]">
      {/* ===== SIDEBAR ===== */}
      <aside className="fixed top-4 bottom-4 left-4 flex w-64 flex-col rounded-3xl border border-white/20 bg-white/70 px-4 py-6 shadow-[0_20px_60px_rgba(0,0,0,0.15)] backdrop-blur-xl dark:bg-white/5">
        {/* BRAND */}
        <div className="mb-10 px-2">
          <h1 className="text-xl font-semibold tracking-tight text-slate-900 dark:text-white">
            Admin Panel
          </h1>
          <p className="mt-1 text-xs text-slate-500">Internal management</p>
        </div>

        {/* NAV */}
        <nav className="flex-1 space-y-2">
          <NavLink to="/admin" end className={linkClass}>
            Dashboard
          </NavLink>

          <NavLink to="/admin/testimonials" className={linkClass}>
            Testimonials
          </NavLink>

          <NavLink to="/admin/case-studies" className={linkClass}>
            Case Studies
          </NavLink>

          <NavLink to="/admin/insights" className={linkClass}>
            Insights
          </NavLink>

          <NavLink to="/admin/contacts" className={linkClass}>
            Contacts
          </NavLink>
        </nav>

        {/* FOOTER ACTIONS */}
        <div className="space-y-3 border-t border-white/20 pt-4">
          {/* THEME TOGGLE */}
          <button
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="w-full rounded-xl border border-white/20 bg-white/60 px-4 py-2 text-sm font-medium transition hover:bg-white/80 dark:bg-white/10 dark:hover:bg-white/20"
          >
            {theme === "dark" ? "Light Mode" : "Dark Mode"}
          </button>

          {/* LOGOUT */}
          <button
            onClick={handleLogout}
            className="w-full rounded-xl px-4 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50"
          >
            Logout
          </button>
        </div>
      </aside>

      {/* ===== MAIN CONTENT ===== */}
      <main className="py-6 pr-6 pl-75">
        <Outlet />
      </main>
    </div>
  );
}
